// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"492":"28afcb9f","870":"87a3275c","877":"0481d05c"}[chunkId] + ".chunk.js";
};